import { render, staticRenderFns } from "./ApnVitana.vue?vue&type=template&id=5418d8bf"
import script from "./ApnVitana.vue?vue&type=script&lang=js"
export * from "./ApnVitana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports